import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import {
  UserIcon,
  MapPinIcon,
  BriefcaseIcon,
  ClockIcon,
  XCircleIcon,
  CheckCircleIcon,
  ClipboardIcon,
  ArrowLeftIcon,
  StarIcon,
  EnvelopeIcon,
  PhoneIcon,
  HomeIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/solid";

import { Key, useEffect, useState } from "react";
import apiClient from "../../services/apiClient";
import { updateVendorApproval } from "../../services/woocommerce";
import { format, parseISO } from "date-fns";
import DocumentModal from "../../hooks/DocumentPreview";
import { ClipboardListIcon, CreditCardIcon, FileTextIcon, PercentIcon, TagIcon } from "lucide-react";

export default function ApprovalDetailsPage() {
  const location = useLocation();
  const { item, type, fromTab, isButtonVisible } = location.state || {};
  console.log(JSON.stringify(item, null, 2));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  console.log('item?.vendor_description:', item?.vendor_address);
  console.log('Active tab from previous page:', fromTab);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState("");
  const [locations, setLocations] = useState<any[]>([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const [consultReviews, setConsultReviews] = useState<any[]>([]);
  console.log("Consult Reviews:", consultReviews);
  const stripHTML = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };
  const openDocumentModal = (src: string) => {
    setModalSrc(src);
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchLocations = async () => {
      if (!item?.user_id) return;
      try {
        setLocationLoading(true);
        const res = await apiClient<any>(
          `v1/resource/UserLocation?user_id=${item.user_id}&is_confirmed=1`
        );
        setLocations(res?.data?.user_locations || []);
      } catch (err) {
        console.error("Failed to fetch user locations:", err);
      } finally {
        setLocationLoading(false);
      }
    };
    fetchLocations();
  }, [item?.user_id]);

  const closeDocumentModal = () => {
    setModalOpen(false);
    setModalSrc("");
  };

  useEffect(() => {
    console.log('Type from URL param:', item);
  }, [type]);



  const isVendor = fromTab === "vendors";
  const isVeterinarian = fromTab === "veterinarians";
  const isvetchargecode = fromTab === "vet_charge_codes";
  const isservicechargecode = fromTab === "sp_charge_codes";
  const isServiceProvider = fromTab === "service_providers";
  const ispets = fromTab === "pets";
  const user = item.user || {};
  const address = user.address || {};
  const timezone = user.timezone || {};
  const additionalInfo = item.additional_info || {};
  const specialityList = item.provider_speciality || [];
  useEffect(() => {
    if (!item?.user_id || (!isVeterinarian && !isServiceProvider)) return;

    const fetchReviews = async () => {
      try {
        setLoading(true);
        const url = isVeterinarian
          ? `v1/resource/ConsultReview?provider_id=${item.user_id}`
          : `v1/resource/ConsultReview?service_provider_id=${item.user_id}`;
        const response: any = await apiClient(url);
        console.log("Fetched reviews response:", response);
        setConsultReviews(response?.data?.consult_reviews || []);
        console.log("Updated consult reviews state:", response?.data?.consult_reviews);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [item?.user_id, isVeterinarian, isServiceProvider]);

  if (!item) return null;


  const InfoRow = ({ label, value, icon: IconComponent }: { label?: string; value: React.ReactNode; icon?: React.ComponentType<any> }) => {
    const displayValue =
      value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
        ? <span className="italic text-gray-400">N/A</span>
        : value;
    return (
      <div className="flex items-center justify-between border-b border-gray-100 py-4 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-purple-50 transition-all duration-200 rounded-xl px-4 group">
        <div className="flex items-center space-x-3">
          {IconComponent && <IconComponent className="h-5 w-5 text-indigo-500 group-hover:text-indigo-600 transition-colors" />}
          <span className="text-gray-700 font-semibold text-sm">{label}</span>
        </div>
        <div className="text-right">
          <span className="text-gray-900 font-medium truncate max-w-md text-sm">{displayValue}</span>
        </div>
      </div>
    );
  };

  const BooleanBadge = ({ value }: { value: boolean }) => (
    <span
      className={`inline-flex px-3 py-1 text-xs font-bold rounded-full shadow-sm transform transition-all duration-200 hover:scale-105 ${value ? "bg-gradient-to-r from-green-100 to-green-200 text-green-800" : "bg-gradient-to-r from-red-100 to-red-200 text-red-800"
        }`}
    >
      {value ? "Yes" : "No"}
    </span>
  );

  const buildPayload = (
    row: any,
    isActive: number,
    role: "veterinarian" | "service_provider"
  ) => {
    console.log("Built payload:", JSON.stringify(row, null, 2));
    const payload = {
      id: row?.user_id,
      license_no: row?.license_no,
      role,
      first_name: row?.user?.first_name,
      mobile: row?.user?.mobile,
      username: row?.user?.username,
      timezone_id: row?.user?.timezone?.id || row?.user?.timezone_id,
      is_2fa: row?.user?.is_2fa,
      is_active: isActive,
    };
    return payload;
  };

  const handleUserAction = async (
    row: any,
    actionLabel: string,
    isActive: number,
    errorMessage: string
  ) => {
    const actionName =
      fromTab === "veterinarians"
        ? `${row?.user?.first_name ?? ""} ${row?.user?.last_name ?? ""}`.trim()
        : row?.name ?? "";
    const role = fromTab === "veterinarians" ? "veterinarian" : "service_provider";
    const payload = buildPayload(row, isActive, role);
    console.log(`Starting action: ${actionLabel}`);
    console.log("Payload being sent:", payload);
    console.log("Target user ID:", row.user_id);
    console.log("Role:", role);
    console.log("Active tab:", fromTab);
    try {
      setLoading(true);
      const response = await apiClient(`v1/resource/users/${row.user_id}`, {
        method: "PUT",
        body: payload,
      });
      console.log(`${actionLabel} API response:`, response);
      alert(`${actionLabel} successful!`);
      navigate(-1);
    } catch (error: any) {
      console.error("Full error object:", error);
      alert(`${errorMessage}: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
      console.log(`${actionLabel} action finished`);
    }
  };

  const handleApprove = () => {
    const userName =
      fromTab === "veterinarians"
        ? `${user.first_name} ${user.last_name}`.trim()
        : item.name ?? "";
    if (window.confirm(`Are you sure you want to approve ${user.first_name} ${user.last_name}?`)) {
      handleUserAction(item, "Approve", 1, "Failed to approve user");
    }
  };

  const handleReject = () => {
    const userName =
      fromTab === "veterinarians"
        ? `${user.first_name} ${user.last_name}`.trim()
        : item.name ?? "";
    if (window.confirm(`Are you sure you want to reject ${userName}?`)) {
      handleUserAction(item, "Reject", 0, "Failed to reject user");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleVendorApprove = async () => {
    if (!window.confirm(`Are you sure you want to approve ${item.store_name || item.name}?`)) return;
    try {
      setLoading(true);
      await updateVendorApproval(item.id, "approve");
      alert("Vendor approved successfully!");
      navigate(-1);
    } catch (error: any) {
      alert(`Failed to approve vendor: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const handleVendorReject = async () => {
    if (!window.confirm(`Are you sure you want to reject ${item.store_name || item.name}?`)) return;
    try {
      setLoading(true);
      await updateVendorApproval(item.id, "reject");
      alert("Vendor rejected successfully!");
      navigate(-1);
    } catch (error: any) {
      alert(`Failed to reject vendor: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  console.log('*********************************************', item)
  const displayAddress = locations[0]?.additional_info?.display_address;
  console.log('*********************************************', locations[0]?.additional_info?.display_address
  )

  if (!item) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50">
          <div className="text-center p-8 bg-white rounded-3xl shadow-2xl border border-indigo-200">
            <p className="text-gray-500 text-xl italic font-medium">No approval details available.</p>
          </div>
        </div>
      </Layout>
    );
  }
  const getFullUrl = (url?: string): string | undefined => {
    const baseUrl = "https://a2zschoolfolio.s3.ap-south-1.amazonaws.com/";
    if (!url) return undefined; // ✅ return undefined instead of null
    return url.startsWith("http") ? url : `${baseUrl}${url}`;
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 ">
            <div className="flex items-center space-x-4 mb-4 sm:mb-0">
              <button
                onClick={handleGoBack}
                className="flex items-center p-3 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 rounded-2xl shadow-md transition-all duration-200 hover:scale-105 hover:shadow-lg"
                aria-label="Go back"
              >
                <ArrowLeftIcon className="h-5 w-5" />
              </button>
              <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-indigo-900 to-purple-900 bg-clip-text text-transparent">
                {type === 'approve'
                  ? ispets
                    ? 'Pet Approval Details'
                    : isVendor
                      ? 'Vendor Approval Details'
                      : isvetchargecode
                        ? 'Charge Code Details'
                        : isservicechargecode ? 'Service Charge Code Details'
                          : isVeterinarian
                            ? 'Veterinarian Approval Details'
                            : 'Service Provider Approval Details'
                  : ispets
                    ? 'Pet Details'
                    : isVendor
                      ? 'Vendor Details'

                      : isVeterinarian
                        ? 'Veterinarian Details'
                        : 'Service Provider Details'
                }
              </h1>
            </div>
            {isButtonVisible && (
              <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
                <button
                  onClick={isVendor ? handleVendorReject : handleReject}
                  disabled={loading}
                  className="flex items-center justify-center px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-2xl shadow-lg hover:from-red-600 hover:to-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105"
                >
                  <XCircleIcon className="h-5 w-5 mr-2" />
                  Reject
                </button>
                <button
                  onClick={isVendor ? handleVendorApprove : handleApprove}
                  disabled={loading}
                  className="flex items-center justify-center px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-2xl shadow-lg hover:from-green-600 hover:to-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105"
                >
                  <CheckCircleIcon className="h-5 w-5 mr-2" />
                  Approve
                </button>
              </div>
            )}
          </div>
          <div className={`grid gap-8 ${!isVendor ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"}`}>
            {isVendor && type === 'approve' && (
              <section className="bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                <header className="flex items-center mb-6 space-x-3">
                  <UserIcon className="text-indigo-600 w-7 h-7" />
                </header>
                <div className="space-y-3">
                  <InfoRow label="Store Name" value={item.store_name || item.name || item?.formatted_display_name} icon={UserIcon} />
                  <InfoRow label="Owner Name" value={item.name || item?.vendor_display_name} icon={UserIcon} />
                  <InfoRow label="Email" value={item.email || item?.vendor_email} icon={UserIcon} />
                  <InfoRow label="Username" value={item.username} icon={UserIcon} />
                  <InfoRow label="Role" value={item.role} icon={BriefcaseIcon} />
                  <InfoRow
                    label="Registered On"
                    value={new Date(item.registered).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                    icon={ClockIcon}
                  />
                  <InfoRow label="Status" value={item.status} icon={CheckCircleIcon} />
                </div>
              </section>
            )}
            {isVendor && (
              <section className="bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100 space-y-6">
                <header className="flex items-center mb-6 space-x-3">
                  <UserIcon className="text-indigo-600 w-7 h-7" />
                  <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">Vendor Information</h2>
                </header>
                <div className="space-y-3">
                  <InfoRow label="Vendor ID" value={item?.vendor_id} icon={UserIcon} />
                  <InfoRow label="Store Name" value={item?.vendor_shop_name} icon={BriefcaseIcon} />
                  <InfoRow label="Vendor Name" value={item?.vendor_display_name?.split('-')[0]?.trim()} icon={UserIcon} />
                  <InfoRow label="Address" value={item?.vendor_address} icon={MapPinIcon} />
                  <InfoRow label="Email" value={item?.vendor_email} icon={EnvelopeIcon} />
                  <InfoRow label="Hide Email" value={<BooleanBadge value={item?.store_hide_email} />} icon={UserIcon} />
                  <InfoRow label="Hide Phone" value={<BooleanBadge value={item?.store_hide_phone} />} icon={PhoneIcon} />
                  <InfoRow label="Hide Address" value={<BooleanBadge value={item?.store_hide_address} />} icon={MapPinIcon} />
                  <InfoRow label="Hide Description" value={<BooleanBadge value={item?.store_hide_description} />} icon={BriefcaseIcon} />
                  <InfoRow label="Hide Policy" value={<BooleanBadge value={item?.store_hide_policy} />} icon={ClipboardIcon} />
                  <InfoRow label="Products Per Page" value={item?.store_products_per_page} icon={BriefcaseIcon} />
                  <InfoRow label="Disable Vendor" value={<BooleanBadge value={item?.disable_vendor} />} icon={XCircleIcon} />
                  <InfoRow label="Is Store Offline" value={<BooleanBadge value={item?.is_store_offline} />} icon={XCircleIcon} />
                  <InfoRow
                    label="Vendor Shop Logo"
                    value={<img src={item?.vendor_shop_logo} alt="logo" className="w-24 h-24 object-contain rounded-xl shadow-md hover:shadow-lg transition-shadow" />}
                  />
                  <InfoRow
                    label="Vendor Banner"
                    value={<img src={item?.vendor_banner} alt="banner" className="w-full h-32 object-cover rounded-xl shadow-md" />}
                  />
                  <InfoRow
                    label="Mobile Banner"
                    value={<img src={item?.mobile_banner} alt="mobile banner" className="w-full h-32 object-cover rounded-xl shadow-md" />}
                  />
                  <InfoRow label="Store Rating" value={item?.store_rating || "N/A"} icon={StarIcon} />
                  <InfoRow label="Email Verified" value={item?.email_verified || "N/A"} icon={CheckCircleIcon} />
                  {item?.vendor_additional_info?.map((info: { label: string; value: string }, idx: number) => (
                    <InfoRow key={idx} label={info.label || `Additional Info ${idx + 1}`} value={info.value || "N/A"} icon={BriefcaseIcon} />
                  ))}
                  <InfoRow label={item?.vendor_policies?.shipping_policy_heading} value={<div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: item?.vendor_policies?.shipping_policy }} />} icon={ClipboardIcon} />
                  <InfoRow label={item?.vendor_policies?.refund_policy_heading} value={<div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: item?.vendor_policies?.refund_policy }} />} icon={ClipboardIcon} />
                  <InfoRow label={item?.vendor_policies?.cancellation_policy_heading} value={<div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: item?.vendor_policies?.cancellation_policy }} />} icon={ClipboardIcon} />
                  <InfoRow label="Products Tab Heading" value={item?.store_tab_headings?.products} icon={BriefcaseIcon} />
                  <InfoRow label="About Tab Heading" value={item?.store_tab_headings?.about} icon={BriefcaseIcon} />
                  <InfoRow label="Reviews Tab Heading" value={stripHTML(item?.store_tab_headings?.reviews)} icon={StarIcon} />
                </div>
                <h2 className="text-lg font-bold text-indigo-900 tracking-tight">Vendor Description</h2>
                <h2 className="text-md text-grey-500 tracking-tight">{stripHTML(item?.vendor_description) || "N/A"}</h2>

              </section>
            )}
            {ispets && (
              <>
                <section className="bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100 md:col-span-1">
                  <header className="flex items-center mb-6 space-x-3">
                    <UserIcon className="text-indigo-600 w-7 h-7" />
                    <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">Pet Information</h2>
                  </header>
                  <div className="space-y-3">
                    <InfoRow label="Name" value={item.additional_info.name} icon={UserIcon} />
                    <InfoRow label="Type" value={item.additional_info.type} icon={BriefcaseIcon} />
                    <InfoRow label="Species" value={item.additional_info.species} icon={BriefcaseIcon} />
                    <InfoRow label="Breed Group" value={item.additional_info.breed_group || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Gender" value={item.additional_info.gender || "-"} icon={UserIcon} />
                    <InfoRow label="Age" value={item.additional_info.age || "-"} icon={ClockIcon} />
                    <InfoRow
                      label="Date of Birth"
                      value={
                        item.additional_info?.dob
                          ? format(parseISO(item.additional_info.dob), "dd-MM-yyyy")
                          : "-"
                      }
                      icon={ClockIcon}
                    />
                    <InfoRow label="Size" value={item.additional_info.size || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Weight" value={item.additional_info.weight || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Color" value={item.additional_info.color || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Pet Type" value={item.additional_info.petType || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Activity Level" value={item.additional_info.activity || "-"} icon={StarIcon} />
                    <InfoRow label="Exercise Needs" value={item.additional_info.exercise || "-"} icon={StarIcon} />
                    <InfoRow label="Grooming Needs" value={item.additional_info.grooming || "-"} icon={StarIcon} />
                    <InfoRow label="Energy Level" value={item.additional_info.energy_level || "-"} icon={StarIcon} />
                    <InfoRow label="Friendliness" value={item.additional_info.friendliness || "-"} icon={StarIcon} />
                    <InfoRow label="Ease of Training" value={item.additional_info.ease_of_training || "-"} icon={StarIcon} />
                    <InfoRow label="Affection Needs" value={item.additional_info.affection_needs || "-"} icon={StarIcon} />
                    <InfoRow label="Characteristics" value={item.additional_info.characteristics || "-"} icon={BriefcaseIcon} />
                  </div>
                </section>
                <section className="bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100 md:col-span-1">
                  <header className="flex items-center mb-6 space-x-3">
                    <BriefcaseIcon className="text-indigo-600 w-7 h-7" />
                    <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">Additional Info</h2>
                  </header>
                  <div className="space-y-3">
                    <InfoRow label="Size of Cage" value={item.additional_info.size_of_cage || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Size of Home" value={item.additional_info.size_of_home || "-"} icon={MapPinIcon} />
                    <InfoRow label="Size of Garden" value={item.additional_info.size_of_garden || "-"} icon={MapPinIcon} />
                    <InfoRow label="Vocalization" value={item.additional_info.vocalization || "-"} icon={StarIcon} />
                    <InfoRow label="Life Span" value={item.additional_info.life_span || "-"} icon={ClockIcon} />
                    <InfoRow
                      label="Profile Image"
                      value={
                        item.additional_info.profile_image ? (
                          <img src={item.additional_info.profile_image} alt="Pet" className="h-32 w-32 object-cover rounded-2xl shadow-lg cursor-pointer hover:scale-105 transition-transform" onClick={() => openDocumentModal(item.additional_info.profile_image)} />
                        ) : "-"
                      }
                    />
                    <InfoRow label="Status" value={item.status || "-"} icon={CheckCircleIcon} />
                    <InfoRow label="Type" value={item.type || "-"} icon={BriefcaseIcon} />
                    <InfoRow label="Created At" value={item.created_at ? new Date(item.created_at).toLocaleString("en-GB") : "-"} icon={ClockIcon} />
                    <InfoRow label="Updated At" value={item.updated_at ? new Date(item.updated_at).toLocaleString("en-GB") : "-"} icon={ClockIcon} />
                  </div>
                </section>
              </>
            )}
            {isservicechargecode && (() => {
              const baseAmount = parseFloat(item.amount);
              const taxes = item.additional_info?.tax_codes || [];

              // Calculate each tax
              const taxDetails = taxes.map((t: { rate: string; type: string; code: any; name: any; }) => {
                let taxAmount = 0;
                const rate = parseFloat(t.rate); // keep rate
                if (t.type === 'percentage') {
                  taxAmount = (baseAmount * rate) / 100;
                } else if (t.type === 'adhoc') {
                  taxAmount = rate;
                }
                return { code: t.code, name: t.name, type: t.type, rate, amount: taxAmount.toFixed(2) };
              });

              // Total amount including taxes
              const totalAmount = (
                baseAmount +
                taxDetails.reduce((sum: number, t: { amount: string; }) => sum + parseFloat(t.amount), 0)
              ).toFixed(2);

              return (
                <section className="md:col-span-2 bg-white/80 rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                  <header className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-3">
                      <CurrencyDollarIcon className="text-indigo-600 w-7 h-7" />
                      <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">
                        Service Charge Code Info
                      </h2>
                    </div>

                    <span
                      className={`px-3 py-1 rounded-full text-white font-semibold ${item.is_active === 1
                        ? 'bg-green-500'
                        : item.is_active === 2
                          ? 'bg-red-500'
                          : 'bg-yellow-500'
                        }`}
                    >
                      {item.is_active === 1
                        ? 'Approved'
                        : item.is_active === 2
                          ? 'Rejected'
                          : 'Pending'}
                    </span>
                  </header>


                  <div className="space-y-3">
                    <InfoRow
                      label="Service Type"
                      value={item.service_type
                        .replace(/[-_]/g, ' ')
                        .replace(/\b\w/g, (char: string) => char.toUpperCase())}
                      icon={ClipboardListIcon}
                    />

                    <InfoRow label="Charge Code" value={item.charge_code} icon={TagIcon} />
                    <InfoRow label="Service Name" value={item.service_name} icon={FileTextIcon} />

                    {/* Base Amount */}
                    <InfoRow label="Amount" value={`₹${baseAmount.toFixed(2)}`} icon={CurrencyDollarIcon} />

                    {/* Highlighted Tax Section */}
                    <div className="p-4 border-l-4 border-indigo-500 bg-indigo-50 rounded-lg space-y-2">
                      <h3 className="text-indigo-700 font-semibold">Taxes</h3>
                      {taxDetails.map((t: { code: Key | null | undefined; name: any; type: string; rate: string; amount: string; }) => (
                        <InfoRow
                          key={t.code}
                          label={`${t.name} (${t.type === 'percentage' ? t.rate + '%' : '₹' + t.amount})`}
                          value={`₹${t.amount}`}
                          icon={PercentIcon}
                        />
                      ))}
                    </div>

                    {/* Total Amount */}
                    <InfoRow label="Total Amount" value={`₹${totalAmount}`} icon={CreditCardIcon} />
                  </div>
                </section>
              );
            })()}

            {isvetchargecode && (() => {
              const baseAmount = parseFloat(item.amount);
              const taxes = JSON.parse(item.tax_codes || '[]') as {
                code: string;
                name: string;
                rate: string;
                type: string;
              }[];

              // Calculate each tax
              const taxDetails = taxes.map(t => {
                let taxAmount = 0;
                const rate = parseFloat(t.rate); // keep rate
                if (t.type === 'percentage') {
                  taxAmount = (baseAmount * rate) / 100;
                } else if (t.type === 'adhoc') {
                  taxAmount = rate;
                }
                return { code: t.code, name: t.name, type: t.type, rate, amount: taxAmount.toFixed(2) };
              });


              // Total amount including taxes
              const totalAmount = (
                baseAmount +
                taxDetails.reduce((sum, t) => sum + parseFloat(t.amount), 0)
              ).toFixed(2);

              return (
                <section className="md:col-span-2 bg-white/80 rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                  <header className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-3">
                      <CurrencyDollarIcon className="text-indigo-600 w-7 h-7" />
                      <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">
                        Charge Code Info
                      </h2>
                    </div>

                    <span
                      className={`px-3 py-1 rounded-full text-white font-semibold ${item.is_active === 1
                        ? 'bg-green-500'
                        : item.is_active === 2
                          ? 'bg-red-500'
                          : 'bg-yellow-500'
                        }`}
                    >
                      {item.is_active === 1
                        ? 'Approved'
                        : item.is_active === 2
                          ? 'Rejected'
                          : 'Pending'}
                    </span>
                  </header>

                  <div className="space-y-3">
                    <InfoRow label="Service Type" value={item.service_type} icon={ClipboardListIcon} />
                    <InfoRow label="Charge Code" value={item.charge_code} icon={TagIcon} />
                    <InfoRow label="Service Name" value={item.service_name} icon={FileTextIcon} />

                    {/* Amount section */}
                    <InfoRow label="Amount" value={`₹${baseAmount.toFixed(2)}`} icon={CurrencyDollarIcon} />

                    {/* Highlighted Tax Section */}
                    <div className="p-4 border-l-4 border-indigo-500 bg-indigo-50 rounded-lg space-y-2">
                      <h3 className="text-indigo-700 font-semibold">Taxes</h3>
                      {taxDetails.map(t => (
                        <InfoRow
                          key={t.code}
                          label={`${t.name} (${t.type === 'percentage' ? t.rate + '%' : '₹' + t.amount})`}
                          value={`₹${t.amount}`}
                          icon={PercentIcon}
                        />
                      ))}
                    </div>

                    <InfoRow label="Total Amount" value={`₹${totalAmount}`} icon={CreditCardIcon} />



                  </div>
                </section>
              );
            })()}



            {(isVeterinarian || isServiceProvider) && (
              <>
                <section className="md:col-span-2 bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                  <header className="flex items-center mb-6 space-x-3">
                    <UserIcon className="text-indigo-600 w-7 h-7" />
                    <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">User Information</h2>
                  </header>
                  <div className="space-y-3">
                    <InfoRow label="Name" value={`${user.first_name} ${user.last_name}`} icon={UserIcon} />
                    <InfoRow label="Email" value={user.email} icon={UserIcon} />
                    <InfoRow label="Mobile" value={`${user.isd_code || ""} ${user.mobile || ""}`} icon={UserIcon} />
                    <InfoRow label="Username" value={user.username} icon={UserIcon} />
                    <InfoRow
                      label="Date of Birth"
                      value={user.dob ? format(parseISO(user.dob), "dd-MM-yyyy") : "-"}
                      icon={ClockIcon}
                    />
                    <InfoRow label="Gender" value={user.gender} icon={UserIcon} />
                    <InfoRow label="Blood Group" value={user.blood_group} icon={UserIcon} />
                    <InfoRow label="2FA Enabled" value={<BooleanBadge value={user.is_2fa} />} icon={CheckCircleIcon} />
                    <InfoRow label="Active" value={<BooleanBadge value={user.is_active} />} icon={CheckCircleIcon} />
                  </div>
                  <header className="flex items-center mt-8 mb-6 space-x-3 pt-6 border-t border-indigo-200">
                    <MapPinIcon className="text-indigo-600 w-7 h-7" />
                    <h3 className="text-xl font-semibold text-indigo-900">Address</h3>
                  </header>
                  {displayAddress ? (
                    <div className="px-2 py-3">
                      <p className="text-gray-700">{displayAddress}</p>
                    </div>
                  ) : (
                    <p className="text-gray-500 italic px-2 py-3">No address available.</p>
                  )}
                </section>
                <section className="md:col-span-2 bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                  <header className="flex items-center mb-6 space-x-3">
                    <BriefcaseIcon className="text-indigo-600 w-7 h-7" />
                    <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">Professional Details</h2>
                  </header>
                  <InfoRow label="License No" value={item?.license_no || additionalInfo?.license_no} />
                  <InfoRow
                    label="Practicing Since"
                    value={
                      additionalInfo.practising_since
                        ? new Date(additionalInfo.practising_since)
                          .toLocaleDateString('en-GB')
                          .replace(/\//g, '-')
                        : 'N/A'
                    }
                  />
                  {isVeterinarian && (
                    <InfoRow label="Qualification" value={additionalInfo.qualification} />)}
                  <InfoRow label="Aadhar Number" value={additionalInfo.aadhar_no} />

                  {(additionalInfo?.avatar_url?.trim() || user?.profile_image?.trim()) && (
                    <InfoRow
                      label="Avatar"
                      value={
                        <img
                          src={getFullUrl(additionalInfo?.avatar_url) || getFullUrl(user?.profile_image) || ''}
                          alt="Avatar"
                          className="h-32 w-32 object-cover rounded-lg shadow-md cursor-pointer hover:opacity-80 transition"
                          onClick={() =>
                            openDocumentModal(getFullUrl(additionalInfo?.avatar_url) || getFullUrl(user?.profile_image) || '')
                          }
                        />
                      }
                    />
                  )}

                  {(additionalInfo?.aadhar_url?.trim() || additionalInfo?.aadhar_image?.trim()) && (
                    <InfoRow
                      label="Aadhar Card"
                      value={
                        <img
                          src={getFullUrl(additionalInfo?.aadhar_url) || getFullUrl(additionalInfo?.aadhar_image) || ''}
                          alt="Aadhar Card"
                          className="h-32 object-contain rounded-md shadow-md cursor-pointer hover:opacity-80 transition"
                          onClick={() =>
                            openDocumentModal(getFullUrl(additionalInfo?.aadhar_url) || getFullUrl(additionalInfo?.aadhar_image) || '')
                          }
                        />
                      }
                    />
                  )}

                  {(additionalInfo?.license_url?.trim() || additionalInfo?.license_image?.trim()) && (
                    <InfoRow
                      label="License"
                      value={
                        <img
                          src={getFullUrl(additionalInfo.license_url || additionalInfo?.license_image) || ''}
                          alt="License"
                          className="h-32 object-contain rounded-md shadow-md cursor-pointer hover:opacity-80 transition"
                          onClick={() => openDocumentModal(getFullUrl(additionalInfo.license_url || additionalInfo?.license_image) || '')}
                        />
                      }
                    />
                  )}

                  <InfoRow label="Bank Name" value={additionalInfo.bank_name} />
                  <InfoRow label="Bank IFSC" value={additionalInfo.bank_ifsc} />
                  <InfoRow label="Bank Account Number" value={additionalInfo.bank_account_number} />
                  {isServiceProvider && (
                    <>
                      {additionalInfo.Business_hours && additionalInfo.Business_hours.trim() !== '' && (
                        <InfoRow label="Business Hours" value={additionalInfo.Business_hours} />
                      )}
                      {additionalInfo.Off_days && additionalInfo.Off_days.trim() !== '' && (
                        <InfoRow label="Off Days" value={additionalInfo.Off_days} />
                      )}
                      <InfoRow label="GSTIN" value={additionalInfo.GSTIN} />

                      {/* <InfoRow label="Bank Name" value={additionalInfo.bank_name} />
                      <InfoRow label="Bank IFSC" value={additionalInfo.bank_ifsc} />
                      <InfoRow label="Bank Account Number" value={additionalInfo.bank_account_number} /> */}
                    </>
                  )}

                  <header className="flex items-center mt-12 mb-6 space-x-4">
                    <ClockIcon className="text-indigo-600 w-8 h-8" />
                    <h2 className="text-3xl font-semibold text-indigo-900 tracking-wide">Timezone</h2>
                  </header>
                  <div className="space-y-3">
                    <InfoRow label="Country Code" value={timezone.country_code || user?.isd_code} icon={MapPinIcon} />
                  </div>
                  {isVeterinarian && (
                    <>
                      <header className="flex items-center mt-8 mb-6 space-x-3 pt-6 border-t border-indigo-200">
                        <ClipboardIcon className="text-indigo-600 w-7 h-7" />
                        <h3 className="text-xl font-semibold text-indigo-900">Specialities</h3>
                      </header>
                      {specialityList.length > 0 ? (
                        <div className="bg-indigo-50 rounded-2xl p-4 max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-100">
                          <ul className="space-y-2">
                            {specialityList.map((spec: any) => (
                              <li key={spec.id} className="flex items-center space-x-2 text-indigo-800 hover:text-indigo-900 transition-colors p-2 rounded-lg hover:bg-indigo-100">
                                <StarIcon className="h-4 w-4 text-yellow-500" />
                                <span>{spec.speciality}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <p className="text-indigo-600 italic bg-indigo-50 p-4 rounded-2xl">No specialities listed.</p>
                      )}
                    </>
                  )}
                  {isServiceProvider && (
                    <>
                      <header className="flex items-center mt-8 mb-6 space-x-3 pt-6 border-t border-indigo-200">
                        <ClipboardIcon className="text-indigo-600 w-7 h-7" />
                        <h3 className="text-xl font-semibold text-indigo-900">Services</h3>
                      </header>
                      {item.services && item.services.length > 0 ? (
                        <div className="bg-indigo-50 rounded-2xl p-4 max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-100">
                          <ul className="space-y-2">
                            {item.services.map((service: any) => (
                              <li key={service.id} className="flex items-center space-x-2 text-indigo-800 hover:text-indigo-900 transition-colors p-2 rounded-lg hover:bg-indigo-100">
                                <CheckCircleIcon className="h-4 w-4 text-green-500" />
                                <span>{service.services_name}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <p className="text-indigo-600 italic bg-indigo-50 p-4 rounded-2xl">No services listed.</p>
                      )}
                      <header className="flex items-center mt-8 mb-6 space-x-3 pt-6 border-t border-indigo-200">
                        <MapPinIcon className="text-indigo-600 w-7 h-7" />
                        <h3 className="text-xl font-semibold text-indigo-900">Service Locations</h3>
                      </header>
                      {additionalInfo.Service_location && additionalInfo.Service_location.length > 0 ? (
                        <div className="bg-indigo-50 rounded-2xl p-4 max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-100">
                          <ul className="space-y-2">
                            {additionalInfo.Service_location.map((location: any) => (
                              <li key={location.slug} className="flex items-center space-x-2 text-indigo-800 hover:text-indigo-900 transition-colors p-2 rounded-lg hover:bg-indigo-100">
                                <MapPinIcon className="h-4 w-4 text-indigo-500" />
                                <span>{location.name}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <p className="text-indigo-600 italic bg-indigo-50 p-4 rounded-2xl">No service locations listed.</p>
                      )}
                    </>
                  )}
                </section>
                <section className="md:col-span-2 bg-white/80  rounded-3xl shadow-2xl p-8 ring-1 ring-indigo-200 hover:shadow-3xl transition-all duration-300 border border-indigo-100">
                  <header className="flex items-center mb-6 space-x-3">
                    <StarIcon className="text-indigo-600 w-7 h-7" />
                    <h2 className="text-2xl font-bold text-indigo-900 tracking-tight">Consult Reviews</h2>
                  </header>
                  {loading ? (
                    <div className="flex justify-center items-center py-12">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                      <span className="ml-3 text-indigo-600">Loading reviews...</span>
                    </div>
                  ) : consultReviews.length > 0 ? (
                    <div className="space-y-4 max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-100 rounded-2xl p-4 bg-indigo-50">
                      {consultReviews.map((review: any) => (
                        console.log("Rendering review:", review),

                        <div key={review.id} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-200 border border-indigo-100">
                          {(review?.consult?.consult_type || review?.additional_ids?.service_name) && (
                            <p className="text-indigo-700 text-sm font-semibold mb-1">
                              {review?.consult?.consult_type
                                ? review.consult.consult_type === "virtual"
                                  ? "Teleconsult"
                                  : review.consult.consult_type === "home"
                                    ? "Home Visit"
                                    : review.consult.consult_type === "clinic"
                                      ? "Walk-In"
                                      : ""
                                : review?.additional_ids?.service_name}
                            </p>
                          )}



                          {review.patient && (
                            <p className="text-gray-700 font-semibold">
                              Patient: {review.patient.first_name} {review.patient.last_name}
                            </p>
                          )}
                          <p className="text-gray-800 font-medium">Comment: {review.comment || review.review || 'No comment provided'}</p>
                          {review.rating && (
                            <div className="flex items-center mb-2">
                              <span className="text-yellow-500 font-semibold">Rating: {review.rating}/5</span>
                              <div className="ml-2 flex">
                                {Array.from({ length: 5 }).map((_, i) => (
                                  <StarIcon key={i} className={`h-4 w-4 ${i < review.rating ? 'text-yellow-500 fill-current' : 'text-gray-300'}`} />
                                ))}
                              </div>
                            </div>
                          )}
                          {(review.consult_id || review?.additional_ids?.order_id) && (
                            <p className="text-gray-600 text-sm mb-1">
                              {review.consult_id
                                ? `Consult ID: ${review.consult_id}`
                                : `Service Order ID: ${review?.additional_ids?.order_id}`}
                            </p>
                          )}

                          {review.created_at && (
                            <p className="text-gray-500 text-sm">
                              {format(parseISO(review.created_at), 'dd-MM-yyyy HH:mm')}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-12 bg-indigo-50 rounded-2xl">
                      <ClipboardIcon className="h-12 w-12 text-indigo-400 mx-auto mb-4" />
                      <p className="text-indigo-600 italic font-medium">No consult reviews available.</p>
                    </div>
                  )}
                </section>
              </>
            )}
          </div>
        </div>
        {modalOpen && <DocumentModal src={modalSrc} onClose={closeDocumentModal} />}
      </div>
    </Layout>
  );
}